import { call, put } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { raiseHandNotificationUpdateRequested } from 'features/notifications/actions';
import { signalingPhoneUserHandLowered } from 'features/sip/actions';
import { logger } from 'utils/logger';

export function* onPhoneUserHandLoweredSaga(
  action: ReturnType<typeof signalingPhoneUserHandLowered>
) {
  if (action.payload.initiator) {
    logger
      .remote({ tier: 1 })
      .info(`Phone user's hand was lowered by user id=${action.payload.initiator.id}`);
  }

  const eventPayload = action.payload.initiator
    ? { initiator: action.payload.initiator.id }
    : undefined;

  yield call(eventBus.sendMessage, 'handLowered', { userId: action.payload.id }, eventPayload);

  yield put(raiseHandNotificationUpdateRequested({ reason: 'hand-lowered' }));
}
